import React from "react";
import "../style/WhyChoosePFA.css";
import logisticsImg from "../../assets/truck.png"; 

const WhyChoosePFA = () => {
  return (
    <section className="why-pfa">
      <div className="why-container">

        {/* Left Content */}
        <div className="why-left">
          <h2>Why Choose PFA Logistics?</h2>
          <p>
            At PFA Logistics Pvt. Ltd., we are committed to providing top-notch
            logistics services that you can rely on. With years of experience,
            we ensure the safe and timely delivery of your goods worldwide.
          </p>

          <div className="why-features">
            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Experience & Expertise</h4>
                <p>Proven track record in international logistics solutions.</p>
              </div>
            </div>

            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Global Network</h4>
                <p>Worldwide connectivity for smooth cargo transport.</p>
              </div>
            </div>

            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Safe & Timely Delivery</h4>
                <p>We ensure secure and on-time shipment of your goods.</p>
              </div>
            </div>

            <div className="feature">
              <span>✔</span>
              <div>
                <h4>Customer Support</h4>
                <p>Dedicated team available to assist you 24/7.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="why-right">
          <img src={logisticsImg} alt="PFA Logistics" />
        </div>

      </div>
    </section>
  );
};

export default WhyChoosePFA;
